import { Component, ElementRef, inject, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SubmittedFormPopupComponent } from '../submitted-form-popup/submitted-form-popup.component';
import { PublicService } from '../../../core/services/public.service';
import {
  NgxIntlTelInputModule,
  CountryISO,
  SearchCountryField,
} from 'ngx-intl-tel-input';
import { NgClass } from '@angular/common';
import { ValidationToastComponent } from '../validation-toast/validation-toast.component';
@Component({
  selector: 'app-contact-form',
  imports: [
    TranslateModule,
    ReactiveFormsModule,
    NgxIntlTelInputModule,
    SubmittedFormPopupComponent,
    NgClass,
    ValidationToastComponent,
  ],
  templateUrl: './contact-form.component.html',
  styleUrl: './contact-form.component.css',
})
export class ContactFormComponent {
  private fb = inject(FormBuilder);
  private publicService = inject(PublicService);

  @ViewChild('phoneInput', { read: ElementRef }) phoneInputRef!: ElementRef;

  contactForm!: FormGroup;

  isSubmitted = false;
  submittedForm = false;

  CountryISO = CountryISO;
  SearchCountryField = SearchCountryField;
  showValidationToast = false;
  constructor() {
    this.initForm();
  }

  ngAfterViewInit() {
    const inputEl = this.phoneInputRef?.nativeElement.querySelector('input');
    if (inputEl) {
      inputEl.setAttribute('autocomplete', 'one-time-code');
    }
  }

  initForm(): FormGroup {
    return (this.contactForm = this.fb.group({
      senderFirstName: [
        '',
        [Validators.required, Validators.pattern(/^[A-Za-z]+(?: [A-Za-z]+)*$/)],
      ],
      senderLastName: [
        '',
        [Validators.required, Validators.pattern(/^[A-Za-z]+(?: [A-Za-z]+)*$/)],
      ],
      senderEmail: [
        '',
        [
          Validators.required,
          Validators.email,
          Validators.pattern(
            '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$'
          ),
        ],
      ],
      countryCode: ['IT', Validators.required],
      mobilePhone: ['', Validators.required],
      emailBody: ['', [Validators.required, Validators.minLength(10)]],
    }));
  }

  getControl(controlName: string): FormControl {
    return this.contactForm.get(controlName) as FormControl;
  }

  onPhoneChange() {
    const phoneValue = this.getControl('mobilePhone').value;

    this.contactForm.patchValue({
      countryCode: phoneValue?.countryCode?.toUpperCase(),
    });

    this.getControl('mobilePhone').updateValueAndValidity();
  }

  buildPayload() {
    const formValue = this.contactForm.value;

    return {
      senderFirstName: formValue.senderFirstName,
      senderLastName: formValue.senderLastName,
      senderEmail: formValue.senderEmail,
      emailBody: formValue.emailBody,
      mobilePhone: formValue.mobilePhone?.nationalNumber,
      countryCode: formValue.mobilePhone?.countryCode?.toUpperCase(),
    };
  }

  resetForm() {
    this.contactForm.reset();
  }

  onSubmit() {
    this.isSubmitted = true;
    this.contactForm.markAllAsTouched();
    if (this.contactForm.invalid) {
      this.showValidationToast = true;
      setTimeout(() => {
        this.showValidationToast = false;
      }, 4000);

      return;
    }
    const payload = this.buildPayload();

    this.publicService.contactUs(payload).subscribe({
      next: (response) => {
        this.isSubmitted = false;
        this.submittedForm = true;
        this.contactForm.reset();
      },
      error: (err) => {
        console.error('API Error:', err);
      },
    });
  }
}
